import type { ReactNode } from 'react';
import { KazbiaLogo, type KazbiaLogoVariant } from './KazbiaLogo.js';

export function AuthShell({
  children,
  wide = false,
  footer,
}: {
  children: ReactNode;
  wide?: boolean;
  footer?: ReactNode;
}) {
  return (
    <div className="auth-page">
      <div className="auth-page-bg" aria-hidden />
      <div className="auth-page-vignette" aria-hidden />
      <main className={`auth-shell ${wide ? 'auth-shell-wide' : ''}`}>
        {children}
      </main>
      {footer ? <footer className="auth-footer">{footer}</footer> : null}
    </div>
  );
}

/** The game's logo over the login / register / reset cards (reference .gate-logo); other variants for the
 *  about page and the "Entering world" cover. */
export function AuthLogo({ subtitle, variant = 'card', after }: { subtitle?: string; variant?: Exclude<KazbiaLogoVariant, 'top'>; after?: Promise<unknown> }) {
  return (
    <header className="auth-logo">
      <KazbiaLogo variant={variant} after={after} />
      {subtitle ? <p>{subtitle}</p> : null}
    </header>
  );
}
